import { render, staticRenderFns } from "./CompassDetails.vue?vue&type=template&id=573cb826&scoped=true&"
import script from "./CompassDetails.vue?vue&type=script&lang=ts&"
export * from "./CompassDetails.vue?vue&type=script&lang=ts&"
import style0 from "./CompassDetails.vue?vue&type=style&index=0&id=573cb826&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573cb826",
  null
  
)

export default component.exports